/**
 * Created by jonas on 2022-10-27.
 */
import {Payday} from "../Payday";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class RestoreUtils {

    constructor() {
    }

    public static startupGame() {
        if (Payday.model.isRestore){
            RestoreUtils.restore();
        } else {
            RestoreUtils.normalStartUp();
        }
    }

    public static normalStartUp() {
    }

    public static restore() {
        if (Payday.model.data.mode == GameMode.FREESPIN)
            Payday.reelView.setToFreespins();
        Payday.reelView.moveClawsTo(Payday.model.clawIndices()).forEach((tween) => tween.progress(1));
        Payday.reelView.clawsGrab().forEach((tl) => tl.progress(1, false));
        Payday.keypadPlugin.setZeroBetSpinCounter(Payday.model.data.freespinsLeft);
        Payday.backgroundElements.restore(Payday.model.data.mode)
        Payday.keypadPlugin.setWin(Payday.model.data.accumulatedRoundWin,
                                       Payday.model.data.mode != GameMode.NORMAL,
                                       Payday.isWinBelowStake());
    }
}